const ANTENA1_PUBLIC_HOST_PATTERN = /(^|\.)antena1\.com\.br$/;
const LOCALHOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const shouldUseGam = () => {
    if (process.env.NODE_ENV === 'production') {
        return true;
    }

    if (typeof window === 'undefined' || !window.location) {
        return false;
    }

    const { hostname } = window.location;

    if (!hostname || LOCALHOSTS.has(hostname)) {
        return false;
    }

    return ANTENA1_PUBLIC_HOST_PATTERN.test(hostname);
};

export default shouldUseGam;
